import ContentSidebar from "../ones/ContentSidebar";

export default function PageWithSidebar({ children }) {
  return (
    <div className="page-with-sidebar">
      <main className="page-main">
        {children}
      </main>

      <ContentSidebar />
    </div>
  );
}
